import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

import DialogLargeDesktop from "./dialog-large-desktop.svg?url";
import DialogTablet from "./dialog-tablet.svg?url";
import PippaLargeDesktop from "./pippa-large-desktop.png";

export const Container = styled.div`
  position: relative;
  inset-block-start: -71px;

  display: flex;
  justify-content: center;
  align-items: center;

  margin-block-end: -71px;
  margin-inline-start: 59px;

  ${theme.breakpoints.up("tablet")} {
    margin-inline-start: 74px;
  }

  ${theme.breakpoints.up("largeDesktop")} {
    flex-direction: column-reverse;

    margin-block-end: -363px;
    margin-inline-start: -1070px;
  }
`;

export const Pippa = styled.div`
  position: relative;
  z-index: 1;

  inline-size: 112px;
  block-size: 154px;

  background-image: url(${PippaLargeDesktop.src});
  background-repeat: no-repeat;
  background-size: contain;

  ${theme.breakpoints.up("tablet")} {
    inline-size: 140px;
    block-size: 196px;
  }

  ${theme.breakpoints.up("largeDesktop")} {
    inline-size: 170px;
    block-size: 240px;
    margin-block-start: -32px;
  }
`;

export const Dialog = styled.div`
  position: relative;

  inline-size: 210px;
  block-size: 204px;
  margin-inline-start: -59px;

  background-image: url(${DialogTablet});
  background-repeat: no-repeat;
  background-size: contain;

  ${theme.breakpoints.up("tablet")} {
    inline-size: 263px;
    block-size: 254px;
    margin-inline-start: -74px;
  }

  ${theme.breakpoints.up("largeDesktop")} {
    z-index: 2;

    inline-size: 222px;
    block-size: 243px;
    margin-inline-start: 0;

    background-image: url(${DialogLargeDesktop});
  }
`;
